import React, { FC, useCallback, useEffect, useState } from 'react';
import { Form } from 'react-final-form';
import apiRoutes from '../../../../config/api/routes';
import { useFetch } from '../../../shared/hooks';
import { VersionRequest } from '../../../../config/api/models/Differentiation';
import { DifferentiationForm } from './DifferentiationForm';
import { ScreenProps } from './DifferentiationsContainer';
import { LogActionTypes, useDataLogging } from '../../../shared/data-logging';
import { useHistory } from 'react-router';
import { useI18nPath } from '../../../../config/clientRoutes/hooks';
import { ICreatedTrajectory } from '../../../../config/api/models/Trajectory';
import { DifferentiationScreenAction } from './DifferentiationScreenAction';

export const NewDifferentiation: FC<ScreenProps> = ({
  openCallback,
  bookId,
  chapterId,
  trajectoryId,
}) => {
  const [submitting, setSubmitting] = useState(false);
  const [postVersionToChapterResponse, postVersionToChapter] = useFetch<ICreatedTrajectory>('', {
    method: 'POST',
  });
  const history = useHistory();
  const { getPath } = useI18nPath();
  const log = useDataLogging();

  const handleAddNewDifferentiation = useCallback(
    (values: VersionRequest) => {
      if (!submitting) {
        postVersionToChapter({
          path: apiRoutes.addTrajectory(chapterId),
          body: {
            title: values.title,
            parent_id: trajectoryId,
          },
        });
        log(LogActionTypes.DIFFERENTIATIONS_CREATE, {
          bookId,
          trajectoryId,
        });
        setSubmitting(true);
      }
    },
    [postVersionToChapter, log, setSubmitting, bookId, chapterId, trajectoryId, submitting]
  );

  useEffect(() => {
    if (postVersionToChapterResponse.success) {
      history.push(
        getPath('trajectoryView', {
          bookId,
          chapterId,
          trajectoryId: postVersionToChapterResponse.data.id,
        })
      );
      openCallback(DifferentiationScreenAction.OVERVIEW);
    }
  }, [postVersionToChapterResponse, openCallback, history, getPath, bookId, chapterId]);

  return (
    <Form
      onSubmit={handleAddNewDifferentiation}
      render={({ handleSubmit }) => (
        <DifferentiationForm
          submitting={submitting}
          handleSubmit={handleSubmit}
          openCallback={openCallback}
        />
      )}
    />
  );
};
